import { ApiError } from '@/lib/api';

/** A bare `snake_case`/`SCREAMING_CASE` identifier, never product copy. */
const CODE_LIKE = /^[A-Za-z0-9_]+$/;

/**
 * Toast copy for a failed mutation: the mapped copy for the error code, then
 * the server's message if it is a real sentence, then `fallback`. Without a
 * server message `ApiError.message` is the bare code, which must not reach the UI.
 */
export function apiErrorMessage(
  err: unknown,
  copy: Record<string, string>,
  fallback: string,
): string {
  if (!(err instanceof Error)) return fallback;
  const code = err instanceof ApiError ? (err.code ?? err.message) : err.message;
  const mapped = copy[code];
  if (mapped) return mapped;
  if (err.message && !CODE_LIKE.test(err.message)) return err.message;
  return fallback;
}
